export default __webpack_public_path__ + "static/media/dashboard-send.c43a3e92.svg";